<template>
    <ContentOrLoading>
        <ShowSvgSectionsComponent
            v-if="svg"
            :secciones="secciones"
            :zona_id="zona_id"
            :svg="svg"
            @clickZona="clickRegion"
        />
    </ContentOrLoading>
</template>

<script setup>
    import { useAbonosSvg } from '@/composables/admin/abonos/useAbonosSvg'
    import ShowSvgSectionsComponent from '@/components/common/svg/secciones/ShowSvgSectionsComponent.vue'

    const props = defineProps({
        secciones: {
            type: Array,
            required: true
        },
        zona_id: {
            type: Number,
            required: false
        }
    })

    const emit = defineEmits(['clickZona'])

    const { svg } = useAbonosSvg({
        svgAlias: 'back.abonos.taquilla.recinto.secciones.svg'
    })

    function clickRegion(zona) {
        emit('clickZona', zona)
    }
</script>
